import mapboxgl from 'mapbox-gl'

let marker: mapboxgl.Marker | null = null

function pinElement(): HTMLElement {
  const el = document.createElement('div')
  el.setAttribute('aria-hidden', 'true')
  el.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path fill="#dc2626" stroke="#fff" stroke-width="1.2" d="M12 22s-7-4.35-7-11a7 7 0 1 1 14 0c0 6.65-7 11-7 11z"/>
    <circle cx="12" cy="11" r="2.5" fill="#fff"/>
  </svg>`
  return el
}

export function setSmartSearchNavigationPin(
  map: mapboxgl.Map,
  lng: number,
  lat: number,
): void {
  removeSmartSearchNavigationPin()
  marker = new mapboxgl.Marker({ element: pinElement(), anchor: 'bottom' })
    .setLngLat([lng, lat])
    .addTo(map)
}

export function removeSmartSearchNavigationPin(): void {
  marker?.remove()
  marker = null
}
